import React, { useCallback } from 'react';
import { BlankImage } from './blank-image';
var FooterSocialIcon = function (_a) {
    var src = _a.src, link = _a.link, spacing = _a.spacing, alt = _a.alt, name = _a.name, onShareClick = _a.onShareClick;
    var aStyle = {
        verticalAlign: 'middle',
        display: 'inline-block',
        textDecoration: 'none',
    };
    var onClick = useCallback(function (e) {
        if (onShareClick) {
            onShareClick(name, e);
        }
    }, [onShareClick, name]);
    return (React.createElement("a", { style: aStyle, href: link, target: "_blank", onClick: onClick },
        React.createElement("img", { className: "social-icon", src: src, width: 28, height: 28, alt: alt }),
        !!spacing && (React.createElement(BlankImage, { className: "social-icon-spacer", width: 6, alt: alt === undefined ? undefined : '' }))));
};
export default FooterSocialIcon;
//# sourceMappingURL=footer-social-icon.js.map